import { css } from '@bts-web/utils-style-engine';
import { SkeletonElement } from '../../../../common';
import { summaryWrapperStyles } from '../WithdrawalSummary/withdrawalSummaryContentStyles';
import {
  scrollableBodyStyles,
  inputSectionStyles,
  borderedSectionStyles,
  availableRowStyles,
  bottomSectionStyles,
  totalsStyles,
  totalRowStyles,
} from './withdrawalAmountStyles';

const navBarSkeletonStyles = css({
  display: 'flex',
  minHeight: '48px',
  alignItems: 'center',
  justifyContent: 'space-between',
  px: 'medium',
});

export const WithdrawalAmountSkeleton = () => (
  <div
    data-testid="withdrawal-amount-skeleton"
    className={summaryWrapperStyles}
  >
    <div className={navBarSkeletonStyles}>
      <div className={css({ flex: 1 })} />

      <SkeletonElement width="100px" height="18px" />

      <div
        className={css({
          flex: 1,
          display: 'flex',
          justifyContent: 'flex-end',
        })}
      >
        <SkeletonElement width="24px" height="24px" borderRadius="50%" />
      </div>
    </div>

    <div className={scrollableBodyStyles}>
      <div className={inputSectionStyles}>
        <div
          className={css({
            display: 'flex',
            alignItems: 'center',
            gap: 'extra_small_2',
          })}
        >
          <SkeletonElement width="24px" height="24px" borderRadius="50%" />

          <SkeletonElement width="40px" height="18px" />
        </div>

        <SkeletonElement width="160px" height="80px" />

        <div
          className={css({
            display: 'flex',
            width: '100%',
            gap: 'extra_small_2',
            py: 'extra_small_2',
          })}
        >
          <SkeletonElement
            style={{ flex: 1 }}
            height="40px"
            borderRadius="8px"
          />

          <SkeletonElement
            style={{ flex: 1 }}
            height="40px"
            borderRadius="8px"
          />

          <SkeletonElement
            style={{ flex: 1 }}
            height="40px"
            borderRadius="8px"
          />

          <SkeletonElement
            style={{ flex: 1 }}
            height="40px"
            borderRadius="8px"
          />
        </div>
      </div>

      <div className={borderedSectionStyles}>
        <div
          className={css({
            pt: 'small',
            pb: 'small',
          })}
        >
          <SkeletonElement width="120px" height="14px" />
        </div>

        <div className={availableRowStyles}>
          <SkeletonElement width="40px" height="40px" borderRadius="50%" />

          <div
            className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: 'extra_small_3',
              flex: 1,
            })}
          >
            <SkeletonElement width="30px" height="12px" />

            <SkeletonElement width="80px" height="16px" />
          </div>

          <div
            className={css({
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              gap: 'extra_small_3',
            })}
          >
            <SkeletonElement width="50px" height="12px" />

            <SkeletonElement width="60px" height="16px" />
          </div>
        </div>
      </div>
    </div>

    <div className={bottomSectionStyles}>
      <div className={totalsStyles}>
        <div className={totalRowStyles}>
          <SkeletonElement width="70px" height="12px" />

          <SkeletonElement width="50px" height="12px" />
        </div>

        <div className={totalRowStyles}>
          <SkeletonElement width="30px" height="12px" />

          <SkeletonElement width="50px" height="12px" />
        </div>

        <div className={totalRowStyles}>
          <SkeletonElement width="40px" height="18px" />

          <SkeletonElement width="60px" height="18px" />
        </div>
      </div>

      <SkeletonElement width="100%" height="56px" borderRadius="4px" />
    </div>
  </div>
);
